import { useParams } from 'react-router-dom';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentAccount } from './useCurrentAccount';
import { fetchWorkflowById } from 'api/workflows';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { workflowQueryKeys } from 'queries/workflow-query-keys';
import { Workflow } from 'types/domain';
import { GivebutterAxiosError } from 'types/error';

interface UseCurrentWorkflowOptions
    extends Omit<
        UseSuspenseQueryOptions<Workflow | null, GivebutterAxiosError, Workflow, any>,
        'queryKey' | 'queryFn'
    > {
    workflowId?: number;
}

const useCurrentWorkflow = (options: UseCurrentWorkflowOptions = {}) => {
    const { workflowId: id, retry = false, ...rest } = options;
    const { accountId } = useCurrentAccount();
    const { workflow_id } = useParams<{ workflow_id: string }>();
    const workflowId = id ?? Number(workflow_id);

    return useSuspenseQuery({
        queryKey: workflowQueryKeys.workflowById(accountId, workflowId),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchWorkflowById(accountId, workflowId),
                !isNaN(workflowId),
            ),
        retry,
        ...rest,
        refetchOnWindowFocus: 'always',
    });
};

export { useCurrentWorkflow };
